import React from 'react'
import { InputControls } from 'components/common'

const OverwriteNameSwitch = ({ canOverwriteName, onOverwriteNameChange }) => {
  return (
    <InputControls
      type='switch'
      label=''
      value={canOverwriteName}
      onChange={onOverwriteNameChange}
    />
  )
}

export default OverwriteNameSwitch